module.exports = __webpack_public_path__ + "img/question-title-desktop.71121353.png";